import { Injectable } from "@angular/core";
import { firstValueFrom, map } from "rxjs";
import { RestService } from "../rest/rest.service";
import { ConfigGlobalModel } from "app/models/config-global-model";

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private config: any;

  constructor(private restService: RestService) { }

  loadConfig(): Promise<ConfigGlobalModel> {
    return firstValueFrom(
      this.restService.getConfigurations()
    ).then(data => this.config = data);
  }

  get settings():ConfigGlobalModel { return this.config; }
}
